import { createFileRoute } from "@tanstack/react-router";
import { TenantCard } from "../features/tenants/pages/tenant-card";

export const Route = createFileRoute("/tenants/$tenantId")({
  component: TenantCard,
});
